<template>
  <l-cache :get-data="getEvent" :id="$route.query.id">
    <violation-detail-content slot-scope="{data}" :event="data"></violation-detail-content>
  </l-cache>
</template>
<script>

import ViolationDetailContent from './violationDetailContent'
export default {
  name: 'ViolationEventDetails',
  components: {ViolationDetailContent},
  methods: {
    async getEvent (key) {
      let {items, amount} = await this.$store.dispatch('violation/getEvents', {
        pagination: {},
        search: {key: 'id', value: key},
        locale: this.$route.query.history ? 'history' : 'runtime'
      })
      if (!amount) {
        throw Error('未找到该事件')
      }
      else {
        return items[0]
      }
    }
  }
}
</script>
